<template>
  <div class="page-template">
    <div class="page-container">
      <!-- 左侧产品信息 -->
      <div class="product-info">
        <div class="aurora-bg"></div>
        <div class="product-logo-container">
          <div class="product-logo">优创</div>
          <div class="product-slogan">AI驱动的智能创作平台，释放你的创意潜能</div>
        </div>
        <div class="feature-cards-group">
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#5e66d7" stroke-width="2">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
            </div>
            <div class="feature-name">AI语音合成</div>
            <div class="feature-desc">将文本转换为自然流畅的语音，支持多种音色和情感</div>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#5e66d7" stroke-width="2">
                <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
                <path
                  d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                />
              </svg>
            </div>
            <div class="feature-name">AI语音复刻</div>
            <div class="feature-desc">仅需几秒音频，精准复刻独特声线，个性化定制</div>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#5e66d7" stroke-width="2">
                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                <line x1="7" y1="2" x2="7" y2="22" />
                <line x1="17" y1="2" x2="17" y2="22" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <line x1="2" y1="7" x2="7" y2="7" />
                <line x1="2" y1="17" x2="7" y2="17" />
                <line x1="17" y1="17" x2="22" y2="17" />
                <line x1="17" y1="7" x2="22" y2="7" />
              </svg>
            </div>
            <div class="feature-name">批量视频生成</div>
            <div class="feature-desc">一键生成多样化视频内容，提高创作效率</div>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#5e66d7" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
            </div>
            <div class="feature-name">批量图片处理</div>
            <div class="feature-desc">智能图像批处理，自动优化与调整</div>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#5e66d7" stroke-width="2">
                <polyline points="16 18 22 12 16 6" />
                <polyline points="8 6 2 12 8 18" />
                <line x1="19" y1="12" x2="5" y2="12" />
              </svg>
            </div>
            <div class="feature-name">智能脚本</div>
            <div class="feature-desc">自动化工作流程，提升创作与处理效率</div>
          </div>
        </div>
        <!-- 装饰元素 -->
        <div class="decoration-element dec-1"></div>
        <div class="decoration-element dec-2"></div>
        <div class="decoration-element dec-3"></div>
        <!-- 粒子效果 -->
        <div class="particles-container" id="particles-container"></div>
      </div>
      <!-- 右侧登录界面 -->
      <div class="login-container">
        <div class="login-header">
          <h1>欢迎登录优创</h1>
          <!-- <p>使用飞书账号或账号密码登录系统</p> -->
          <p>使用飞书账号登录系统</p>
        </div>
        <div class="login-tabs">
          <!-- <div class="login-tab active" @click="switchTab('feishu')">飞书登录</div> -->
          <!-- <div class="login-tab" @click="switchTab('account')">账号密码登录</div> -->
        </div>
        <div class="login-content">
          <!-- 飞书登录面板  -->
          <div class="login-panel active" id="feishu-panel">
            <div style="text-align: center; margin-bottom: 30px">
              <img :src="Feishulogo" style="border-radius: 12px; width: 80px; height: 80px" />
              <p style="margin-top: 16px; font-size: 16px; color: #333">使用飞书账号快速登录</p>
            </div>
            <button class="btn-redirect" @click="feishuPanel">
              <img
                :src="Feishulogo"
                style="vertical-align: middle; margin-right: 8px; width: 20px; height: 30px"
              />
              前往飞书授权登录
            </button>
          </div>
          <!-- 账号密码登录面板 -->
          <div class="login-panel" id="account-panel">
            <form>
              <div class="form-group">
                <label class="form-label">用户名/邮箱</label>
                <input type="text" class="form-input" placeholder="请输入用户名或邮箱" />
              </div>
              <div class="form-group">
                <label class="form-label">密码</label>
                <input type="password" class="form-input" placeholder="请输入密码" />
              </div>
              <div class="forgot-password">
                <a href="#">忘记密码？</a>
              </div>
              <div class="form-checkbox">
                <input type="checkbox" id="remember-me" />
                <label for="remember-me">记住我</label>
              </div>
              <button type="submit" class="btn-login">登录</button>
            </form>
          </div>
        </div>
        <div class="login-footer">
          <p>登录即表示您同意《服务条款》和《隐私政策》</p>
          <!-- <el-checkbox v-model="checkbox" size="large">
            <span>
              登录即表示您同意
              <span @click="toggleTermsVisible" style="color: blue; cursor: pointer;">
                《服务条款》
              </span>
              和
              <span @click="toggleTermsVisible" style="color: blue; cursor: pointer;">《隐私政策》</span>
            </span>
          </el-checkbox> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, nextTick, onMounted, toRefs, computed, watchEffect } from 'vue'
import * as Auth from '../service/auth'
import Feishulogo from '@/assets/feishulogo.png'
const checkbox = ref(false)
// 标签切换
const switchTab = (tab) => {
  // 移除所有active类
  document.querySelectorAll('.login-tab').forEach((el) => {
    el.classList.remove('active')
  })
  document.querySelectorAll('.login-panel').forEach((el) => {
    el.classList.remove('active')
  })

  // 添加active类到选中的tab
  if (tab === 'feishu') {
    document.querySelectorAll('.login-tab')[0].classList.add('active')
    document.getElementById('feishu-panel').classList.add('active')
  } else if (tab === 'account') {
    document.querySelectorAll('.login-tab')[1].classList.add('active')
    document.getElementById('account-panel').classList.add('active')
  }
}
// 定义 code 变量
const code = ref('')

// 飞书授权重定向函数
const feishuPanel = () => {
  Auth.getURL()
    .then(({ data }) => {
      console.log('飞书授权重定向函数', data)
      const targetUrl = data

      const url = new URL(data)
      const codeValue = url.searchParams.get('code')
      const stateValue = url.searchParams.get('state')
      if (stateValue) {
        localStorage.setItem('feishuCode', codeValue)
        localStorage.setItem('feishuState', stateValue)
      }
      window.location.href = targetUrl
    })
    .catch(function (e) {
      // 从服务端获取重定向地址失败,失败后的处理
      console.error('重定向地址失败', e)
    })
}
</script>

<style setup>
.page-template {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #333;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    sans-serif;
}

.page-container {
  display: flex;
  width: 1100px;
  height: 640px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

/* 左侧产品信息区域 */
.product-info {
  flex: 1;
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    rgba(240, 248, 255, 0.6),
    rgba(230, 230, 250, 0.6),
    rgba(220, 255, 230, 0.6)
  );
}

/* 科幻宇宙背景 */
.aurora-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at 70% 20%,
    rgba(178, 235, 242, 0.4) 0%,
    rgba(102, 126, 234, 0.2) 25%,
    rgba(142, 223, 176, 0.2) 50%,
    rgba(188, 156, 255, 0.1) 75%,
    rgba(230, 230, 250, 0.05) 100%
  );
  z-index: -1;
  opacity: 0.7;
}

.product-logo-container {
  position: absolute;
  top: 50px;
  left: 60px;
  z-index: 2;
}

.product-logo {
  font-family: 'Orbitron', sans-serif;
  font-size: 56px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(45deg, #5e66d7, #8a8edb, #68c9b9);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0px 2px 10px rgba(94, 102, 215, 0.3);
  margin-bottom: 16px;
}

.product-slogan {
  font-size: 16px;
  color: #667eea;
  margin-top: 10px;
  font-weight: 500;
  letter-spacing: 0.5px;
  max-width: 450px;
  white-space: nowrap;
}

/* 功能卡片悬浮样式 */
.feature-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(94, 102, 215, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.8);
  transition: all 0.5s ease;
  z-index: 2;
  width: 200px;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 36px rgba(94, 102, 215, 0.25);
}

.feature-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.feature-icon svg {
  width: 24px;
  height: 24px;
}

.feature-name {
  font-family: 'Orbitron', sans-serif;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #5e66d7;
  margin-bottom: 6px;
}

.feature-desc {
  font-size: 12px;
  color: #667;
  line-height: 1.4;
}

/* 设置卡片群组的位置，让它们分散但形成群组 */
.feature-cards-group {
  position: absolute;
  bottom: 60px;
  right: 60px;
  width: 500px;
  height: 300px;
  z-index: 3;
}

/* 恢复原始文件中的卡片位置 */
.feature-card:nth-child(1) {
  position: absolute;
  top: -80px;
  left: 150px;
  animation: float 8s ease-in-out infinite;
  animation-delay: 0.5s;
}

.feature-card:nth-child(2) {
  position: absolute;
  top: 30px;
  left: -40px;
  animation: float 7s ease-in-out infinite;
  animation-delay: 0s;
}

.feature-card:nth-child(3) {
  position: absolute;
  top: 10px;
  right: -20px;
  animation: float 9s ease-in-out infinite;
  animation-delay: 1s;
}

.feature-card:nth-child(4) {
  position: absolute;
  bottom: 0px;
  left: 30px;
  animation: float 6s ease-in-out infinite;
  animation-delay: 1.5s;
}

.feature-card:nth-child(5) {
  position: absolute;
  bottom: -10px;
  right: 30px;
  animation: float 8.5s ease-in-out infinite;
  animation-delay: 2s;
}

/* 悬浮装饰元素 */
.decoration-element {
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  filter: blur(10px);
}

.dec-1 {
  width: 120px;
  height: 120px;
  top: 15%;
  left: 20%;
  background: linear-gradient(45deg, rgba(142, 223, 176, 0.2), rgba(102, 126, 234, 0.2));
  animation: float-slow 15s ease-in-out infinite;
}

.dec-2 {
  width: 180px;
  height: 180px;
  bottom: 10%;
  right: 15%;
  background: linear-gradient(135deg, rgba(188, 156, 255, 0.15), rgba(142, 223, 176, 0.15));
  animation: float-slow 18s ease-in-out infinite;
  animation-delay: 3s;
}

.dec-3 {
  width: 80px;
  height: 80px;
  top: 60%;
  left: 35%;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.2), rgba(178, 235, 242, 0.2));
  animation: float-slow 12s ease-in-out infinite;
  animation-delay: 1s;
}

/* 创建微小的悬浮粒子 */
.particles-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: rgba(152, 186, 244, 0.6);
  border-radius: 50%;
}

/* 右侧登录区域 */
.login-container {
  width: 420px;
  background-color: white;
  padding: 0;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-shadow: -5px 0 15px rgba(94, 102, 215, 0.05);
}

.login-header {
  text-align: center;
  padding: 36px 0 24px;
}

.login-header h1 {
  font-size: 26px;
  font-weight: 600;
  color: #5e66d7;
  margin-bottom: 8px;
}

.login-header p {
  font-size: 14px;
  color: #667;
}

.login-tabs {
  display: flex;
  border-bottom: 1px solid #eee;
}

.login-tab {
  flex: 1;
  text-align: center;
  padding: 16px 0;
  cursor: pointer;
  position: relative;
  font-weight: 500;
  font-size: 16px;
}

.login-tab.active {
  color: #5e66d7;
}

.login-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  height: 3px;
  background-color: #5e66d7;
  border-radius: 3px 3px 0 0;
}

.login-content {
  padding: 36px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.login-panel {
  display: none;
  flex: 1;
}

.login-panel img {
  display: initial;
}

.login-panel.active {
  display: block;
}

/* 飞书登录按钮样式 */
.btn-redirect {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #5e66d7, #8a8edb);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 20px;
}

.btn-redirect:hover {
  background: linear-gradient(45deg, #4c54c5, #7a7ecb);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(94, 102, 215, 0.2);
}

/* 账号密码表单样式 */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-input:focus {
  border-color: #5e66d7;
  box-shadow: 0 0 0 2px rgba(94, 102, 215, 0.2);
  outline: none;
}

.form-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-checkbox input {
  margin-right: 8px;
}

.btn-login {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #5e66d7, #8a8edb);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-login:hover {
  background: linear-gradient(45deg, #4c54c5, #7a7ecb);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(94, 102, 215, 0.2);
}

.login-footer {
  text-align: center;
  font-size: 13px;
  color: #667;
  padding: 16px 32px 32px;
}

/* App logo flyfish */
.logo-feishu {
  display: inline-block;
  padding: 4px 8px;
  background-color: white;
  border-radius: 4px;
  margin-right: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

.logo-feishu span {
  font-size: 14px;
  font-weight: bold;
  color: #3370ff;
}

/* 忘记密码链接 */
.forgot-password {
  text-align: right;
  margin-bottom: 20px;
}

.forgot-password a {
  color: #5e66d7;
  font-size: 14px;
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 1100px) {
  .page-container {
    width: 100%;
    height: 100%;
    flex-direction: column;
    border-radius: 0;
  }

  .product-info {
    padding: 32px;
    height: 40vh;
  }

  .login-container {
    width: 100%;
    height: 60vh;
  }

  .feature-card {
    position: relative;
    margin: 10px;
    animation: none !important;
    transform: none !important;
  }
}

/* 动画效果 */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes float-slow {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-10px, 10px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.5;
  }
}
</style>